import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronSquareRight, faUserCircle } from '@fortawesome/pro-regular-svg-icons';

import { ITypeaheadOption } from '../../types';
import { Template } from './elements/Template';
import { Order } from './elements/Order';
import { EGiftPurchaseOrder } from './elements/EGiftPurchaseOrder';

import styles from './index.module.sass';

interface Props {
  item: ITypeaheadOption;
}

export const OptionFactory: React.FC<Props> = ({ item }) => {
  switch (item.__typename) {
    case 'fastCustomer':
      return (
        <Template>
          <span className={`${styles.quickAccess} px-1 mr-2 bg-light`}>
            <FontAwesomeIcon className="mr-2" icon={faChevronSquareRight} />
            Go To
          </span>
          <strong>{`Customer #${item.id}`}</strong>
        </Template>
      );
    case 'fastOrder':
      return (
        <Template>
          <span className={`${styles.quickAccess} px-1 mr-2 bg-light`}>
            <FontAwesomeIcon className="mr-2" icon={faChevronSquareRight} />
            Go To
          </span>
          <strong>{`Order #${item.id}`}</strong>
        </Template>
      );
    case 'IndexedCustomer':
      return (
        <Template icon={faUserCircle} title={`Customer #${item.id}`}>
          <div className="text-truncate mt-1">
            {item.name && (
              <div className="mb-2">
                <strong className="d-block">Name:</strong>
                {item.name}
                <br />
              </div>
            )}
            {item.email && (
              <div className="mb-2">
                <strong className="d-block">Email:</strong>
                {item.email}
              </div>
            )}
            {item.phone && (
              <div className="mb-2">
                <strong className="d-block">Phone:</strong>
                {item.phone}
              </div>
            )}
          </div>
        </Template>
      );
    case 'IndexedOrder':
      if (item.egiftRecipientEmail) {
        return <EGiftPurchaseOrder item={item} />;
      }

      return <Order item={item} />;
    default:
      return null;
  }
};
